import type { ReactNode } from 'react';
import styles from './Title.module.css';

export interface TitleProps {
  children: ReactNode;
  button?: ReactNode;
  subtitle?: string;
  className?: string;
}

export function Title({ children, button, subtitle, className }: TitleProps) {
  const classNames = [styles.title, className].filter(Boolean).join(' ');

  return (
    <div className={classNames}>
      <h1 className={styles.heading}>
        {children}
        {subtitle && (
          <>
            <span className={styles.subtitle}>{subtitle}</span>
          </>
        )}
      </h1>
      {button && button}
    </div>
  );
}

Title.displayName = 'Title';
